











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GitLabScopingSearchFilterMenuRoot_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "PokerMeeting",
  "abstractKey": null
};

(node ).hash = "036a0b3158e0cd25d966d0d630e1769e";

export default node;
